// @ts-nocheck

import styled, { css } from 'styled-components';

import { ReactComponent as ArrowLeft } from '../../../../assets/svg/chevron-left.svg';
import { Target } from '../../../../client';

export const Bloc = styled.div`
  ${({ theme }) => theme.grids.desktopBloc}
  margin-bottom: 1em;
  color: #fff;
  padding: 0 1em;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  min-height: 70px;

  ${Target.__MOBILE__
    ? undefined
    : css`
        &:hover {
          background: #fff;
          color: ${({ theme }) => theme.grids.colors.black};

          & svg {
            stroke: ${({ theme }) => theme.grids.colors.black};
          }
        }
      `}
`;

export const Span = styled.span``;

export const ArrowPrevious = styled(ArrowLeft)`
  display: block;
  height: auto;
  width: 0.6em;
  margin: 0 1em 0 0;
`;
